
import { NSDataModelInfo } from './data_model_info';
import { NSObjDetails } from './obj_details';
import { URN as NSURN } from './utils/urn';


export let NSGoTo = {}



NSGoTo.f_go_to_urn = function(s_record_urn, f_callback)
{
    return NSGoToPrivate.gotoUrn(s_record_urn, f_callback);
}

let NSGoToPrivate = 
{
    gotoUrn: function( s_record_urn, f_callback)
    {
        let this_ = this;
    
        let s_table_urn =  NSURN.f_create_table_urn_from_record_urn(s_record_urn);
    
        NSDataModelInfo.f_load_table____returning_promise({
            b_full_info: false,
            s_table_urn: s_table_urn
        }).then((a_values) => {
            //console.log("---------- startup_action - just called f_load_table____returning_promise");
            //console.log("---------- table loaded: " + s_table_urn );
            
            this_.gotoUrn_part_2(s_record_urn, f_callback);
        });
    
    
    
        
       
    },
    
    gotoUrn_part_2: function(s_record_urn, f_callback)
    {
    
        let a_urn_info = NSURN.f_get_urn_info(s_record_urn);
        let s_schema = a_urn_info[1];
        let s_table_internal_name = a_urn_info[2];
        
        //let o_table_info = NSDataModelInfo.f_get_table_info(s_schema, s_table_internal_name);
        let o_geom_field_info = NSDataModelInfo.f_get_table_first_geometry_field_info(s_schema, s_table_internal_name);
    
        let b_go_to = true;;
    
        /**
            @example
            o_in:
            {
                tree_node_id,
                s_urn, 
                b_clean_join_list,
                o_ll,						// (optional) - {google.maps.LatLng}
                o_geo_json					// (optional) - {GeoJson}
                s_geometry_internal_name	// internal name of the geometry field
                b_is_icon,
                a_icon_size_xy,				//[width, height]
                b_go_to,
                f_callback
            }
        */
        NSObjDetails.f_open_details_by_urn({
            s_urn: s_record_urn,
            s_geometry_internal_name: (o_geom_field_info)? o_geom_field_info.internal_name : null,
            b_go_to: b_go_to,
            f_callback: f_callback
        });
    }

}
	
